"use client";

import { useContext, useEffect } from "react";
import { AppContext } from "@/context/AppContext";
import { WorkCase } from "@/data/types";
import Hero from "./workCaseDetail/Hero";
import MetaInfo from "./workCaseDetail/MetaInfo";
import ContentSection from "./workCaseDetail/ContentSection";
import CodeExampleSection from "./workCaseDetail/CodeExampleSection";
import ImageGallery from "./workCaseDetail/ImageGallery";
import NavigationFooter from "./workCaseDetail/NavigationFooter";
import TechnologiesSection from "./workCaseDetail/TechnologiesSection";

interface WorkCaseDetailClientProps {
  workCase: WorkCase;
}

export function WorkCaseDetailClient({ workCase }: WorkCaseDetailClientProps) {
  const { setActivePage } = useContext(AppContext);
  const content = workCase.detailContent!;

  useEffect(() => {
    setActivePage("work");
    // Smooth scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [setActivePage]);

  return (
    <div className="w-full py-4 md:py-16 transition-all duration-400 max-w-6xl mx-auto">
      <Hero workCase={workCase} subtitle={content.subtitle} />

      <div className="max-w-5xl mx-auto sm:px-6 lg:px-0">
        <MetaInfo
          title={workCase.title}
          tags={workCase.tags}
          link={workCase.link}
        />

        <div>
          <ContentSection
            title="Herausforderung"
            content={content.challenge}
            colorScheme="purple"
          />

          <ContentSection
            title="Lösung"
            content={content.solution}
            colorScheme="pink"
          />

          {content.codeExamples && content.codeExamples.length > 0 && (
            <CodeExampleSection
              codeExamples={content.codeExamples}
            />
          )}

          <ContentSection
            title="Ergebnisse"
            content={content.results}
            colorScheme="blue"
          />

          {content.images && content.images.length > 0 && (
            <ImageGallery
              images={content.images}
            />
          )}
        </div>

        <TechnologiesSection slug={workCase.slug} delay={0.2} />

        <NavigationFooter />
      </div>
    </div>
  );
}